import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ComponentDefaultsLockUnlockService {

  constructor(private http: HttpClient) {}

  /**
   * Lock or Unlock component defaults.
   * AngularJS: DefaultBatchServiceFactory.saveLockAndUnLocking(ccs, _flag)
   * URL: GENERAL_CONFIG.base_url + "/saveJsonObject?action_code=vs0vf8"
   * Merges: GlobalService.globalParams + filterParams + { p_cc_key, p_is_locked, process_name }
   */
  saveLockAndUnLocking(
    baseUrl: string,
    globalParams: any,
    filterParams: any,
    ccKeys: string,
    lockFlag: string
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=vs0vf8`;

    const params: any = { ...globalParams, ...filterParams };
    params.p_cc_key = ccKeys;
    params.p_is_locked = lockFlag;
    params.process_name = 'components-grid-save';

    const body = new URLSearchParams();
    Object.keys(params).forEach(k => {
      if (params[k] !== undefined && params[k] !== null) {
        body.set(k, String(params[k]));
      }
    });

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }
}
